import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import useModalContext from '@hooks/context/useModalContext';
import { useTranslation } from 'react-i18next';
import { prettifyStars } from '@utils/index';
import InfoBlock from '@components/common/info_block';

const DeleteAccountModal = () => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'delete_account'
    });
    const { modalData } = useModalContext();
    return (
        <div className={styles.wrapper}>
            <Typography className={styles.title} variant="h4">
                Remove bank account
            </Typography>
            <Typography variant="body2" alignment="center">
                {modalData?.account_name} {prettifyStars(modalData?.account_number)} {t('removed')}
            </Typography>
            <InfoBlock variant="warning">
                Please note: Any pending or scheduled payments set up with this account will be
                canceled. Remember to make other arrangements for future payments you may still owe.
            </InfoBlock>
        </div>
    );
};

export default DeleteAccountModal;
